module.exports = __webpack_public_path__ + "img/hero_portrait_barbarian_female.91b023d0.png";